<div>

  <div style="display:flex; flex-direction: row; gap: 10px; margin-bottom: 15px;">
    <app-radio-group [options]="transactionTypeOptions" [(ngModel)]="orderDetails.transactionType" (onChanged)="handleTransactionTypeChanged()"></app-radio-group>
  </div>
  <div class="flex-container" style="width: 100%; gap: 20px" [hidden]="hidden">

    <div style="display: flex;flex-direction: column;flex-basis: 100%;flex: 1;align-self: start;">
      <div class="column">
        <!-- <app-textbox [label]="'Charge Amount'" [(ngModel)]="orderDetails.totalAmount" [type]="InputTextModes.CurrencyUSD" [helpText]="'The amount to charge the customer'" [validateOn]="'change'" ()></app-textbox> -->
        <app-textbox [readonly]="!allowChargeAmountChange" [label]="'Charge Amount'" width="100%" [minNumericValue]="0" [showDefaultValue]="false" [required]="true" [type]="InputTextModes.CurrencyUSD" [validateOn]="'change'" (onChanged)="txtChargeAmount_keyup()" [(ngModel)]="orderDetails.totalAmount" ></app-textbox>
      </div>

      <div class="column">
        <app-textbox [label]="'Invoice number'" [helpText]="'If not entered, a number will be generated automatically'"  [(ngModel)]="orderDetails.invoiceNumber"  (onChanged)="handleInvoiceNumberChanged($event)"></app-textbox>
      </div>

      <div class="column">
        <app-textbox [label]="'PO number'" [helpText]="'If not entered, a number will be generated automatically'" [(ngModel)]="orderDetails.poNumber" (onChanged)="handlePoNumberChanged($event)"></app-textbox>
      </div>
    </div>

    <div style="display: flex; flex-direction: column; flex-basis: 100%; flex: 1;  align-self: start;">
      <div class="column">
        <app-multiline [label]="'Order details'" [(ngModel)]="orderDetails.description" (onChanged)="handleDescriptionChanged($event)"></app-multiline>
      </div>

      <div [hidden]="true" style=" margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #eeeeee;">
        <app-terminal-L2L3 [hidden]="true" [L2L3Data]="L2L3Data"></app-terminal-L2L3>
      </div>

    </div>

  </div>

  <div class="greenContainer" [hidden]="orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_RECUR">
    <div style="margin-bottom: 15px;">
      Recurring Payment Info
    </div>
    <app-terminal-recurring-form
      *ngIf="orderDetails.recurringSchedule"
      [recurringSchedule]="orderDetails.recurringSchedule"
      (recurringScheduleChange)="handleRecurringUpdate($event)">
    </app-terminal-recurring-form>

  </div>
</div>
